import type { ProductSizeOption } from '@repo/api-contracts';
import type { ReactElement } from 'react';

interface SizeChipListProps {
  readonly options: readonly ProductSizeOption[];
}

/** 상품 사이즈 목록 — 선택하지 않는 정보용 칩이다. */
export const SizeChipList = ({ options }: SizeChipListProps): ReactElement | null =>
  options.length === 0 ? null : (
    <section aria-label="사이즈" className="space-y-2">
      <h2 className="text-sm font-medium">사이즈</h2>
      <ul className="flex flex-wrap gap-1.5">
        {options.map((option) => (
          <li
            key={option.id}
            className="rounded-full border border-foreground/15 px-3 py-1 text-sm"
          >
            {option.name}
          </li>
        ))}
      </ul>
    </section>
  );
